import axios from "axios";


export const OPDFetch = () => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/v1/OPD`);
  };

  export const OPDPrint = (opdId) => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/v1/OPD?opdId=${opdId}`);
  };

